<template>
  <div class="container" ref="container">
    <audio src="static/img/music.mp3" id="audio" preload="auto" loop></audio>
    <div class="shoushiintro" ref="shoushiintro" @click="hide">
      <v-touch @swipeleft="swipelefthide" class="wrapper">
        <img src="static/img/left.gif" class="left" alt="" />
      </v-touch>
    </div>
    <v-touch
      v-on:swipeleft="swiperleft"
      v-on:swiperight="swiperright"
      class="wrapper"
    >
      <div class="menu-container" ref="menuContainer">
        <transition
          name="top"
          enter-active-class="animate__animated animate__wobble"
          leave-active-class="animate__animated animate__bounceOutUp"
          mode="out-in"
        >
          <img
            src="static/img/2-1.png"
            alt=""
            v-if="flag === 0"
            key="1"
            class="title animate__animated animate__swing"
          />
          <img
            src="static/img/2-2.png"
            alt=""
            v-if="flag === 1"
            key="2"
            class="title animate__animated animate__swing"
          />
          <img
            src="static/img/2-3.png"
            alt=""
            v-if="flag === 2"
            key="3"
            class="title animate__animated animate__swing"
          />
          <!-- <img src="static/img/2-4.png" alt="" v-if="flag === 3" key="4" class="title animate__animated animate__swing"> -->
          <img
            src="static/img/2-5.png"
            alt=""
            v-if="flag === 3"
            key="5"
            class="title animate__animated animate__swing"
          />
          <img
            src="static/img/2-6.png"
            alt=""
            v-if="flag === 4"
            key="6"
            class="title animate__animated animate__swing"
          />
          <img
            src="static/img/2-7.png"
            alt=""
            v-if="flag === 5"
            key="7"
            class="title animate__animated animate__swing"
          />
        </transition>

        <transition
          name="main"
          enter-active-class="animate__animated animate__fadeIn"
          leave-active-class="animate__animated animate__fadeOut"
          mode="out-in"
          appear
          @after-enter="enter"
        >
          <img
            src="static/img/1-1.png"
            alt=""
            class="main"
            v-if="flag === 0"
            key="1"
          />
          <img
            src="static/img/1-2.png"
            alt=""
            class="main"
            v-if="flag === 1"
            key="2"
          />
          <img
            src="static/img/1-3.png"
            alt=""
            class="main"
            v-if="flag === 2"
            key="3"
          />
          <!-- <img src="static/img/1-4.png" alt="" class="main" v-if="flag === 3" key="4"> -->
          <img
            src="static/img/1-5.png"
            alt=""
            class="main"
            v-if="flag === 3"
            key="5"
          />
          <img
            src="static/img/1-6.png"
            alt=""
            class="main"
            v-if="flag === 4"
            key="6"
          />
          <img
            src="static/img/1-7.png"
            alt=""
            class="main"
            v-if="flag === 5"
            key="7"
          />
        </transition>

        <img
          src="static/img/circle2.png"
          style="z-index: 1"
          class="circle"
          alt=""
          v-show="flag != 7"
        />
        <img
          src="static/img/circle1.png"
          style="z-index: 2"
          class="circle"
          alt=""
          v-show="flag != 7"
        />
        <img src="static/img/car.png" class="car" alt="" v-show="flag != 7" />
        <transition
          name="intro"
          appear
          enter-active-class="animate__animated animate__fadeIn"
          leave-active-class="animate__animated animate__fadeOut"
          mode="out-in"
        >
          <img
            src="static/img/3-1.png"
            class="intro"
            v-if="flag === 0"
            key="1"
            alt=""
          />
          <img
            src="static/img/3-2.png"
            class="intro"
            v-if="flag === 1"
            key="2"
            alt=""
          />
          <img
            src="static/img/3-3.png"
            class="intro"
            v-if="flag === 2"
            key="3"
            alt=""
          />
          <!-- <img src="static/img/3-4.png" class="intro" v-if="flag === 3" key="4" alt=""> -->
          <img
            src="static/img/3-5.png"
            class="intro"
            v-if="flag === 3"
            key="5"
            alt=""
          />
          <img
            src="static/img/3-6.png"
            class="intro"
            v-if="flag === 4"
            key="6"
            alt=""
          />
          <img
            src="static/img/3-7.png"
            class="intro"
            v-if="flag === 5"
            key="7"
            alt=""
          />
        </transition>
        <img
          src="static/img/bt.png"
          class="bt"
          alt=""
          v-show="flag < 6"
          @click="urlchange"
        />
        <img
          src="static/img/btlink.png"
          class="btlink"
          v-show="flag == 6"
          @click="linkto"
          alt=""
        />
        <img src="static/img/pop.gif" class="pop" v-show="flag == 6" alt="" />
        <!-- people.jpg -->
        <img
          src="http://pic-cdn.bigdatajy.com/data/upload/upload/portal/20221008/634118cb6cce5.jpg"
          style="width: 100%; height: 100%; overflow: hidden"
          v-show="flag == 7"
          alt=""
        />
        <img
          src="static/img/tree1.png"
          v-show="flag != 7"
          class="house"
          alt=""
        />
        <img
          src="static/img/tree3.png"
          v-show="flag != 7"
          class="tree3"
          alt=""
        />
        <img
          src="static/img/tree2.png"
          v-show="flag != 7"
          class="tree2"
          alt=""
        />
      </div>
    </v-touch>
  </div>
</template>
<script>
export default {
  name: "cut",
  data() {
    return {
      flag: "",
    };
  },
  created() {
    this.flag = 0;
  },
  activated() {
    console.log("=================== cut.vue ");
    // var wx = require('weixin-js-sdk');
    // wx.config({
    //     debug: false,
    //     appId: '',
    //     timestamp: 1,
    //     nonceStr: '',
    //     signature: '',
    //     jsApiList: [],
    //     info:{}
    // });
    // wx.ready(function() {
    // alert('a1111');
    // var video = document.querySelector("#audio");
    // console.log('111 - ',video);
    // video.play();
    // console.log('111 - mp3');

    // });
    var video = document.getElementById("audio");
    //console.log(video);
    if (window.WeixinJSBridge) {
      WeixinJSBridge.invoke(
        "getNetworkType",
        {},
        function (e) {
          console.log("111a");
          video.play();
        },
        false
      );
    } else {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
            console.log("222a");
            video.play();
          });
        },
        false
      );
    }
  },
  watch: {
    flag(val) {
      console.log(val);
      if (val == 6) {
        this.$refs.container.style.background = "#aa0000";
      } else {
        this.$refs.container.style.background = "#e1e1e1";
      }
    },
  },
  methods: {
    swipelefthide() {
      this.$refs.shoushiintro.style.display = "none";
    },
    hide() {
      this.$refs.shoushiintro.style.display = "none";
    },
    swiperleft() {
      console.log("向左滑");
      if (this.flag < 7) {
        this.flag += 1;
      }
      console.log(this.flag);
    },
    swiperright() {
      console.log("向右滑");
      if (this.flag > 0) {
        this.flag -= 1;
      }
      console.log(this.flag);
    },
    enter(el) {
      el.style.transform = "translateX(-44vw)";
    },
    urlchange() {
      this.$router.push({
        name: "detail",
        query: {
          id: this.flag,
        },
      });
    },
    linkto() {
      this.$router.push("/mapcom");
    },
  },
};
</script>
<style scoped>
.shoushiintro {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
.left {
  position: absolute;
  right: 33vw;
  top: 58vw;
  width: 34vw;
}
.wrapper {
  height: 100%;
}
.container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #e1e1e1;
  transform: rotate(0deg);
}
.title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.circle {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.main {
  height: 100vw;
  margin-top: 20vw;
  /* animation: move 5s ease-in-out 1;
  animation-fill-mode:forwards */
}
.main-enter-to {
  animation: move 5s ease-in-out 1;
  /* animation-fill-mode:forwards */
}
.car {
  position: absolute;
  bottom: 70vw;
  width: 35vw;
  left: 33vw;
  animation: carmove 0.3s linear infinite;
  z-index: 1;
}
.intro {
  position: absolute;
  bottom: 20vw;
  left: 5%;
  width: 90%;
  z-index: 2;
}
.bt {
  position: absolute;
  bottom: 6vw;
  left: 25%;
  width: 50%;
  z-index: 2;
}
.btlink {
  position: absolute;
  bottom: 20vw;
  left: 25%;
  width: 50%;
  z-index: 2;
}
.pop {
  position: absolute;
  bottom: 80vw;
  width: 36vw;
  left: 52vw;
}
.tree2 {
  position: absolute;
  bottom: 66vw;
  left: 41vw;
  width: 18vw;
  transform-origin: center 152vw;
  animation: treemovefront 3s linear infinite;
  z-index: 1;
}
.tree3 {
  position: absolute;
  bottom: 72vw;
  left: 41vw;
  width: 18vw;
  transform-origin: center 152vw;
  transform: rotate(-35deg);
  animation: treemovefront 5s linear 2s infinite;
}
.house {
  position: absolute;
  bottom: 73vw;
  left: 42vw;
  width: 16vw;
  transform-origin: center 152vw;
  transform: rotate(-35deg);
  animation: treemovefront 5s linear 3s infinite;
}
/* 主体图片移动动画 */
@keyframes move {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-44vw);
  }
}
/* 小车移动动画 */
@keyframes carmove {
  0% {
    transform: translateX(0);
    transform: translateY(0);
  }
  25% {
    transform: translateY(-0.2vw);
  }
  50% {
    transform: translateX(2vw);
    transform: translateY(0);
  }
  75% {
    transform: translateY(0.2vw);
  }
  100% {
    transform: translateX(0);
    transform: translateY(0);
  }
}
/* tree2移动动画 */
@keyframes treemovefront {
  0% {
    transform: rotate(35deg);
  }
  100% {
    transform: rotate(-35deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cut.vue